import WebFont from 'webfontloader';

WebFont.load({
    google: {
        families: ['Merriweather:400,700&display=swap'],
    },
});
